import React from 'react'

const OneOffTag = () => {
  return (
    <div className='flex items-center px-2 h-[20px] text-xs border-1 text-gray-400 border-gray-400'>
      one-off
    </div>
  )
}
export default React.memo(OneOffTag)
